var map = {
	"./assets/SBKRumiko-Bold.woff2": 61369,
	"./assets/SBKRumiko-Regular.woff2": 6068,
	"./assets/_commonjsHelpers-CqkleIqs": 50174,
	"./assets/_commonjsHelpers-CqkleIqs.js": 50174,
	"./assets/_commonjsHelpers-CqkleIqs.js.map": 77289,
	"./assets/accordion-Cv7tkc0n": 79573,
	"./assets/accordion-Cv7tkc0n.js": 79573,
	"./assets/accordion-Cv7tkc0n.js.map": 93140,
	"./assets/alert-Cz1C1tZi": 78934,
	"./assets/alert-Cz1C1tZi.js": 78934,
	"./assets/alert-Cz1C1tZi.js.map": 29247,
	"./assets/announcement-CriX9nNn": 62689,
	"./assets/announcement-CriX9nNn.js": 62689,
	"./assets/announcement-CriX9nNn.js.map": 9346,
	"./assets/announcement-D1kvTNMC.css": 87473,
	"./assets/base-Boy68Nhk": 93031,
	"./assets/base-Boy68Nhk.js": 93031,
	"./assets/base-Boy68Nhk.js.map": 55408,
	"./assets/base-CcVp4kVi.css": 61859,
	"./assets/bottomNavigation-CGI-GqLY.css": 1802,
	"./assets/bottomNavigation-crfUm-jI": 79539,
	"./assets/bottomNavigation-crfUm-jI.js": 79539,
	"./assets/bottomNavigation-crfUm-jI.js.map": 31160,
	"./assets/breadcrumb-BFcAQbN1": 76602,
	"./assets/breadcrumb-BFcAQbN1.js": 76602,
	"./assets/breadcrumb-BFcAQbN1.js.map": 66085,
	"./assets/button--onDark.styles-DnSVf0w0": 98856,
	"./assets/button--onDark.styles-DnSVf0w0.js": 98856,
	"./assets/button--onDark.styles-DnSVf0w0.js.map": 80541,
	"./assets/button-group-BYippF2D.css": 23948,
	"./assets/chLoadMoreTeaser-B31-OcWY.css": 85309,
	"./assets/chLoadMoreTeaser-BmPiZFv1": 70430,
	"./assets/chLoadMoreTeaser-BmPiZFv1.js": 70430,
	"./assets/chLoadMoreTeaser-BmPiZFv1.js.map": 43053,
	"./assets/chNav-CRrV6UGi": 42409,
	"./assets/chNav-CRrV6UGi.js": 42409,
	"./assets/chNav-CRrV6UGi.js.map": 16964,
	"./assets/chNavItem-DAfX84PB": 74307,
	"./assets/chNavItem-DAfX84PB.js": 74307,
	"./assets/chNavItem-DAfX84PB.js.map": 52818,
	"./assets/chSurvey-8Mhe5H0d": 69425,
	"./assets/chSurvey-8Mhe5H0d.js": 69425,
	"./assets/chSurvey-8Mhe5H0d.js.map": 66950,
	"./assets/chSurvey-C_cVMmfd.css": 19778,
	"./assets/citation-teaser-Dpz66y6P.css": 61331,
	"./assets/citation-teaser-DxkloHTe": 21558,
	"./assets/citation-teaser-DxkloHTe.js": 21558,
	"./assets/citation-teaser-DxkloHTe.js.map": 59703,
	"./assets/class-map-DaxCX8SI": 47918,
	"./assets/class-map-DaxCX8SI.js": 47918,
	"./assets/class-map-DaxCX8SI.js.map": 26579,
	"./assets/contactFlyout-V_7ERMC5": 60146,
	"./assets/contactFlyout-V_7ERMC5.js": 60146,
	"./assets/contactFlyout-V_7ERMC5.js.map": 82983,
	"./assets/content-slider.styles-CxNV-t78": 97225,
	"./assets/content-slider.styles-CxNV-t78.js": 97225,
	"./assets/content-slider.styles-CxNV-t78.js.map": 22016,
	"./assets/contentSlider-bzj4oE4p": 86079,
	"./assets/contentSlider-bzj4oE4p.js": 86079,
	"./assets/contentSlider-bzj4oE4p.js.map": 87046,
	"./assets/cookie-layer-00ENyUxO": 10633,
	"./assets/cookie-layer-00ENyUxO.js": 10633,
	"./assets/cookie-layer-00ENyUxO.js.map": 70954,
	"./assets/cookie-layer-Dg_n0jOJ.css": 48997,
	"./assets/cookie-overlay-qwPm6KPA": 98473,
	"./assets/cookie-overlay-qwPm6KPA.js": 98473,
	"./assets/cookie-overlay-qwPm6KPA.js.map": 47650,
	"./assets/cookieLayer-B64hUMK0": 94029,
	"./assets/cookieLayer-B64hUMK0.js": 94029,
	"./assets/cookieLayer-B64hUMK0.js.map": 54672,
	"./assets/copy-link-DEjZ8fOA": 3816,
	"./assets/copy-link-DEjZ8fOA.js": 3816,
	"./assets/copy-link-DEjZ8fOA.js.map": 11249,
	"./assets/custom-element-BhZVzxrc": 93234,
	"./assets/custom-element-BhZVzxrc.js": 93234,
	"./assets/custom-element-BhZVzxrc.js.map": 15237,
	"./assets/data-protection-Ddt6jLcb": 19960,
	"./assets/data-protection-Ddt6jLcb.js": 19960,
	"./assets/data-protection-Ddt6jLcb.js.map": 76269,
	"./assets/data-protection-DniBZCOT.css": 48993,
	"./assets/datawrapper-DPhEBnXG": 80062,
	"./assets/datawrapper-DPhEBnXG.js": 80062,
	"./assets/datawrapper-DPhEBnXG.js.map": 1995,
	"./assets/datawrapperEventlistener-DCUjlIED": 16764,
	"./assets/datawrapperEventlistener-DCUjlIED.js": 16764,
	"./assets/datawrapperEventlistener-DCUjlIED.js.map": 46203,
	"./assets/directive-Ctav8iJK": 87946,
	"./assets/directive-Ctav8iJK.js": 87946,
	"./assets/directive-Ctav8iJK.js.map": 43435,
	"./assets/eht-BPdNeFTw": 2782,
	"./assets/eht-BPdNeFTw.js": 2782,
	"./assets/eht-BPdNeFTw.js.map": 78787,
	"./assets/eht-DCfQhzJm.css": 94740,
	"./assets/ehtEnrollmentDeclarationLink-Of403BwF": 72749,
	"./assets/ehtEnrollmentDeclarationLink-Of403BwF.js": 72749,
	"./assets/ehtEnrollmentDeclarationLink-Of403BwF.js.map": 67030,
	"./assets/errorBanner-B5ebOtiC": 94232,
	"./assets/errorBanner-B5ebOtiC.js": 94232,
	"./assets/errorBanner-B5ebOtiC.js.map": 98841,
	"./assets/facet-2--onDark.styles-BLswIpI8": 73508,
	"./assets/facet-2--onDark.styles-BLswIpI8.js": 73508,
	"./assets/facet-2--onDark.styles-BLswIpI8.js.map": 3947,
	"./assets/footer-_MhHw8US": 96953,
	"./assets/footer-_MhHw8US.js": 96953,
	"./assets/footer-_MhHw8US.js.map": 11758,
	"./assets/form-BUfJGMcF": 60953,
	"./assets/form-BUfJGMcF.js": 60953,
	"./assets/form-BUfJGMcF.js.map": 24658,
	"./assets/form-D_MLTjmZ.css": 50519,
	"./assets/form-control-dependency-mixin-BmSk-rJk": 36914,
	"./assets/form-control-dependency-mixin-BmSk-rJk.js": 36914,
	"./assets/form-control-dependency-mixin-BmSk-rJk.js.map": 35975,
	"./assets/form-validation-mixin-CWz6_AF-": 67300,
	"./assets/form-validation-mixin-CWz6_AF-.js": 67300,
	"./assets/form-validation-mixin-CWz6_AF-.js.map": 68829,
	"./assets/gallery-BtLzNmbY.css": 82364,
	"./assets/gallery-hzlF3FbC": 10093,
	"./assets/gallery-hzlF3FbC.js": 10093,
	"./assets/gallery-hzlF3FbC.js.map": 75104,
	"./assets/hero-slider.styles-Ea130-RL": 2042,
	"./assets/hero-slider.styles-Ea130-RL.js": 2042,
	"./assets/hero-slider.styles-Ea130-RL.js.map": 6085,
	"./assets/heroSlider-CONkK4T_": 74667,
	"./assets/heroSlider-CONkK4T_.js": 74667,
	"./assets/heroSlider-CONkK4T_.js.map": 13016,
	"./assets/heroTeaser-BGpAm8S9.css": 37165,
	"./assets/heroTeaser-Bok0E-52": 93746,
	"./assets/heroTeaser-Bok0E-52.js": 93746,
	"./assets/heroTeaser-Bok0E-52.js.map": 64385,
	"./assets/image-C3XFXZEk": 54780,
	"./assets/image-C3XFXZEk.js": 54780,
	"./assets/image-C3XFXZEk.js.map": 41769,
	"./assets/jobListing-BH3EclGO": 49267,
	"./assets/jobListing-BH3EclGO.js": 49267,
	"./assets/jobListing-BH3EclGO.js.map": 8820,
	"./assets/jobListing-DjD-c4yX.css": 39022,
	"./assets/leadmanagement-BAeMcd4f.css": 39965,
	"./assets/leadmanagement-X7Ff3dp6": 71156,
	"./assets/leadmanagement-X7Ff3dp6.js": 71156,
	"./assets/leadmanagement-X7Ff3dp6.js.map": 70935,
	"./assets/leadmanagementSlider-B1dMkBSL.css": 68718,
	"./assets/leadmanagementSlider-DJV8gRfw": 46365,
	"./assets/leadmanagementSlider-DJV8gRfw.js": 46365,
	"./assets/leadmanagementSlider-DJV8gRfw.js.map": 62242,
	"./assets/link--onDark.styles-DxjBwP18": 87536,
	"./assets/link--onDark.styles-DxjBwP18.js": 87536,
	"./assets/link--onDark.styles-DxjBwP18.js.map": 63797,
	"./assets/link-C4WoqxGq": 44147,
	"./assets/link-C4WoqxGq.js": 44147,
	"./assets/link-C4WoqxGq.js.map": 78740,
	"./assets/lit-element-DDcuVA3y": 89972,
	"./assets/lit-element-DDcuVA3y.js": 89972,
	"./assets/lit-element-DDcuVA3y.js.map": 87369,
	"./assets/loading-animation-CW-K57jU": 93979,
	"./assets/loading-animation-CW-K57jU.js": 93979,
	"./assets/loading-animation-CW-K57jU.js.map": 79898,
	"./assets/magazin-B_HCeWCG": 1996,
	"./assets/magazin-B_HCeWCG.js": 1996,
	"./assets/magazin-B_HCeWCG.js.map": 80833,
	"./assets/magazin-CJQgdQHp.css": 89091,
	"./assets/mainNav-DqSFCoP3": 42690,
	"./assets/mainNav-DqSFCoP3.js": 42690,
	"./assets/mainNav-DqSFCoP3.js.map": 24979,
	"./assets/map-BTiu792s": 60340,
	"./assets/map-BTiu792s.js": 60340,
	"./assets/map-BTiu792s.js.map": 91769,
	"./assets/map-CExTf2oc": 10001,
	"./assets/map-CExTf2oc.js": 10001,
	"./assets/map-CExTf2oc.js.map": 90668,
	"./assets/metaNav-Bd0xN9wX": 93611,
	"./assets/metaNav-Bd0xN9wX.js": 93611,
	"./assets/metaNav-Bd0xN9wX.js.map": 53798,
	"./assets/minimal-header-DFvFES3b.css": 19284,
	"./assets/oip-CBbNXJhe": 37429,
	"./assets/oip-CBbNXJhe.js": 37429,
	"./assets/oip-CBbNXJhe.js.map": 47384,
	"./assets/oip-CKqgwZdY.css": 62606,
	"./assets/oipCoverLetter-KxaWbXOu": 83171,
	"./assets/oipCoverLetter-KxaWbXOu.js": 83171,
	"./assets/oipCoverLetter-KxaWbXOu.js.map": 66984,
	"./assets/oipModuleSelect-CbiNW7Vh.css": 69696,
	"./assets/oipModuleSelect-DbgKwI-a": 77099,
	"./assets/oipModuleSelect-DbgKwI-a.js": 77099,
	"./assets/oipModuleSelect-DbgKwI-a.js.map": 55666,
	"./assets/personal-advising-BPIiQCmf.css": 89187,
	"./assets/personal-advising-jDe29mH7": 85695,
	"./assets/personal-advising-jDe29mH7.js": 85695,
	"./assets/personal-advising-jDe29mH7.js.map": 4310,
	"./assets/photoswipe.esm-GXRgw7eJ": 13331,
	"./assets/photoswipe.esm-GXRgw7eJ.js": 13331,
	"./assets/photoswipe.esm-GXRgw7eJ.js.map": 10612,
	"./assets/property-1JAdfsvf": 33293,
	"./assets/property-1JAdfsvf.js": 33293,
	"./assets/property-1JAdfsvf.js.map": 14438,
	"./assets/query-__j_ZMY6": 21614,
	"./assets/query-__j_ZMY6.js": 21614,
	"./assets/query-__j_ZMY6.js.map": 94235,
	"./assets/query-assigned-elements-B9QUVdYT": 69636,
	"./assets/query-assigned-elements-B9QUVdYT.js": 69636,
	"./assets/query-assigned-elements-B9QUVdYT.js.map": 60429,
	"./assets/repeatable-container-DSF3eaPe": 17107,
	"./assets/repeatable-container-DSF3eaPe.js": 17107,
	"./assets/repeatable-container-DSF3eaPe.js.map": 17988,
	"./assets/rte-BOdMRqMF": 80776,
	"./assets/rte-BOdMRqMF.js": 80776,
	"./assets/rte-BOdMRqMF.js.map": 48869,
	"./assets/rte-Bsmm2g8l.css": 78065,
	"./assets/rte-BvruG7e7": 80137,
	"./assets/rte-BvruG7e7.js": 80137,
	"./assets/rte-BvruG7e7.js.map": 5264,
	"./assets/sbk-CThPNY2L.css": 49748,
	"./assets/sbk-CirIy_fx": 20984,
	"./assets/sbk-CirIy_fx.js": 20984,
	"./assets/sbk-CirIy_fx.js.map": 99397,
	"./assets/sbk-element-D0ymjRIy": 78660,
	"./assets/sbk-element-D0ymjRIy.js": 78660,
	"./assets/sbk-element-D0ymjRIy.js.map": 91761,
	"./assets/search-filter-nav-JZhGL4-x.css": 16823,
	"./assets/search-filter-nav-izdl72aP": 32581,
	"./assets/search-filter-nav-izdl72aP.js": 32581,
	"./assets/search-filter-nav-izdl72aP.js.map": 74252,
	"./assets/search-result-C639JbxJ.css": 30669,
	"./assets/search-result-qKk0DjHX": 65214,
	"./assets/search-result-qKk0DjHX.js": 65214,
	"./assets/search-result-qKk0DjHX.js.map": 39723,
	"./assets/searchFlyout-Bgr45Npe": 1483,
	"./assets/searchFlyout-Bgr45Npe.js": 1483,
	"./assets/searchFlyout-Bgr45Npe.js.map": 11904,
	"./assets/searchInput-DCTZ-WeY": 84012,
	"./assets/searchInput-DCTZ-WeY.js": 84012,
	"./assets/searchInput-DCTZ-WeY.js.map": 40829,
	"./assets/searchSuggestionItem-DzoWXG3T": 86504,
	"./assets/searchSuggestionItem-DzoWXG3T.js": 86504,
	"./assets/searchSuggestionItem-DzoWXG3T.js.map": 3755,
	"./assets/searchSuggestionList-DAInMhLB": 47308,
	"./assets/searchSuggestionList-DAInMhLB.js": 47308,
	"./assets/searchSuggestionList-DAInMhLB.js.map": 11343,
	"./assets/service-navigation-item-AZ0hYy5c": 86204,
	"./assets/service-navigation-item-AZ0hYy5c.js": 86204,
	"./assets/service-navigation-item-AZ0hYy5c.js.map": 83701,
	"./assets/signature-CtgMhOXp.css": 91354,
	"./assets/sliderControl-DfXY8Lb4": 30967,
	"./assets/sliderControl-DfXY8Lb4.js": 30967,
	"./assets/sliderControl-DfXY8Lb4.js.map": 39337,
	"./assets/state-D77yjKEp": 2529,
	"./assets/state-D77yjKEp.js": 2529,
	"./assets/state-D77yjKEp.js.map": 29932,
	"./assets/tab-menu--onDark.styles-DPUyobeK": 60588,
	"./assets/tab-menu--onDark.styles-DPUyobeK.js": 60588,
	"./assets/tab-menu--onDark.styles-DPUyobeK.js.map": 17905,
	"./assets/tab-menu-CjdR2i07": 7139,
	"./assets/tab-menu-CjdR2i07.js": 7139,
	"./assets/tab-menu-CjdR2i07.js.map": 4272,
	"./assets/tag-list-CVSx497Y": 96551,
	"./assets/tag-list-CVSx497Y.js": 96551,
	"./assets/tag-list-CVSx497Y.js.map": 92948,
	"./assets/targetGroups-7aOpxUbg": 25379,
	"./assets/targetGroups-7aOpxUbg.js": 25379,
	"./assets/targetGroups-7aOpxUbg.js.map": 16900,
	"./assets/targetGroupsElement-CQ8KUW_8": 83690,
	"./assets/targetGroupsElement-CQ8KUW_8.js": 83690,
	"./assets/targetGroupsElement-CQ8KUW_8.js.map": 607,
	"./assets/teaser-link--ne_Qkcd": 81120,
	"./assets/teaser-link--ne_Qkcd.js": 81120,
	"./assets/teaser-link--ne_Qkcd.js.map": 99145,
	"./assets/teaser-link-BqxSXyCP.css": 84221,
	"./assets/unsafe-html-IgFVxnfP": 69781,
	"./assets/unsafe-html-IgFVxnfP.js": 69781,
	"./assets/unsafe-html-IgFVxnfP.js.map": 26868,
	"./assets/variables-BWf6YqMz": 40276,
	"./assets/variables-BWf6YqMz.js": 40276,
	"./assets/variables-BWf6YqMz.js.map": 62385,
	"./assets/vpt-BMg27ULH.css": 91384,
	"./assets/vpt-BxUL0-WS": 79169,
	"./assets/vpt-BxUL0-WS.js": 79169,
	"./assets/vpt-BxUL0-WS.js.map": 20020,
	"./assets/wst-BLUhpge-": 26003,
	"./assets/wst-BLUhpge-.js": 26003,
	"./assets/wst-BLUhpge-.js.map": 6706,
	"./assets/wst-DIuIH1oY.css": 87770,
	"./facets/facet-1.svg": 80620,
	"./facets/facet-10.svg": 66644,
	"./facets/facet-11.svg": 39253,
	"./facets/facet-12.svg": 51030,
	"./facets/facet-13.svg": 14855,
	"./facets/facet-14.svg": 25672,
	"./facets/facet-15.svg": 7417,
	"./facets/facet-16.svg": 16042,
	"./facets/facet-17.svg": 76411,
	"./facets/facet-18.svg": 13244,
	"./facets/facet-19.svg": 2717,
	"./facets/facet-2.svg": 43295,
	"./facets/facet-20.svg": 22845,
	"./facets/facet-21.svg": 52220,
	"./facets/facet-22.svg": 31247,
	"./facets/facet-23.svg": 68670,
	"./facets/facet-24.svg": 77601,
	"./facets/facet-25.svg": 65360,
	"./facets/facet-26.svg": 26851,
	"./facets/facet-27.svg": 88914,
	"./facets/facet-28.svg": 96053,
	"./facets/facet-29.svg": 70420,
	"./facets/facet-3.svg": 28654,
	"./facets/facet-30.svg": 25474,
	"./facets/facet-31.svg": 56051,
	"./facets/facet-32.svg": 65312,
	"./facets/facet-33.svg": 5873,
	"./facets/facet-34.svg": 40398,
	"./facets/facet-35.svg": 78335,
	"./facets/facet-36.svg": 99308,
	"./facets/facet-37.svg": 34765,
	"./facets/facet-38.svg": 9018,
	"./facets/facet-39.svg": 14283,
	"./facets/facet-4.svg": 40209,
	"./facets/facet-40.svg": 42451,
	"./facets/facet-5.svg": 42176,
	"./facets/facet-6.svg": 86835,
	"./facets/facet-7.svg": 99458,
	"./facets/facet-8.svg": 20805,
	"./facets/facet-9.svg": 23556,
	"./icons/sprite.svg": 83500,
	"./logo/apostrophe.svg": 409,
	"./logo/favicon.png": 59376,
	"./logo/favicon.svg": 69686,
	"./logo/logo-sbk-mini.svg": 35674,
	"./logo/logo-sbk-white.svg": 19094,
	"./logo/logo-sbk-with-claim-blue.svg": 43061,
	"./logo/logo-sbk-with-claim-en-blue.svg": 26237,
	"./logo/logo-sbk-with-claim-en.svg": 32772,
	"./logo/logo-sbk-with-claim.svg": 35244,
	"./logo/logo-sbk.svg": 1658
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54910;